import React from "react";

const icon = () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12.9375 9.5625H5.0625C4.752 9.5625 4.5 9.3105 4.5 9C4.5 8.6895 4.752 8.4375 5.0625 8.4375H12.9375C13.248 8.4375 13.5 8.6895 13.5 9C13.5 9.3105 13.248 9.5625 12.9375 9.5625Z" fill="#EDA211"/>
        <path d="M9 13.5C8.6895 13.5 8.4375 13.248 8.4375 12.9375V5.0625C8.4375 4.752 8.6895 4.5 9 4.5C9.3105 4.5 9.5625 4.752 9.5625 5.0625V12.9375C9.5625 13.248 9.3105 13.5 9 13.5Z" fill="#EDA211"/>
    </svg>
);

export default icon